import { Stack, TextField } from '@mui/material';
import { Control, FieldErrors, UseFormRegisterReturn } from 'react-hook-form';
import { isNotNullOrUndefined } from '@vy/utils';
import { get } from 'lodash';
import { INTEGRATION_TYPES } from '@vy/integrations-types';
import { useActivatedIntegration } from '../../../../../../hooks/use-activated-integration';
import { NetSuiteProductsDropdown } from '../../../../../plans/CreatePlanPage/create-plan-page-components/FixedChargeEditDrawer/fixed-charge-edit-drawer-components/components/NetSuiteProductsDropdown';
import { CreateProductDialogFormInput } from '../create-product-dialog-types/create-product-dialog-form-input-schema';
import { CatalogProductsFormData } from '../create-product-dialog-types/catalog-products-form-schema';
import {
  AnrokProductInput,
  NetSuiteClassDropdownForCatalog,
  QuickBooksProductsDropdownForCatalog,
  XeroProductsDropdownForCatalog,
} from '../UpsertCatalogProductsDialog/components';

type CreateProductDialogContentProps = {
  control: Control<CreateProductDialogFormInput, unknown>;
  errors: FieldErrors<CreateProductDialogFormInput>;
  nameRegister: UseFormRegisterReturn<string>;
  descriptionRegister: UseFormRegisterReturn<string>;
};

export const CreateProductDialogContent: React.FC<CreateProductDialogContentProps> = ({
  control,
  errors,
  nameRegister,
  descriptionRegister,
}) => {
  const isNetSuiteConnected = useActivatedIntegration(INTEGRATION_TYPES.NETSUITE);
  const isQuickBooksConnected = useActivatedIntegration(INTEGRATION_TYPES.QUICKBOOKS);
  const isXeroConnected = useActivatedIntegration(INTEGRATION_TYPES.XERO);
  const isAnrokConnected = useActivatedIntegration(INTEGRATION_TYPES.ANROK);

  const nameError = get(errors, nameRegister.name)?.message;

  return (
    <Stack spacing={3}>
      <TextField
        label="Product name"
        placeholder="Enter product name"
        fullWidth
        size="small"
        {...nameRegister}
        error={isNotNullOrUndefined(nameError)}
        helperText={nameError}
      />

      <TextField
        label="Description"
        placeholder="Enter a description of what this product includes"
        fullWidth
        size="small"
        {...descriptionRegister}
      />

      {isNetSuiteConnected && (
        <>
          <NetSuiteProductsDropdown
            fieldPath="netSuiteProduct"
            control={control}
            showDropdown={true}
            placeholder="Select NetSuite product"
          />
          <NetSuiteClassDropdownForCatalog control={control as Control<CatalogProductsFormData>} />
        </>
      )}

      {isQuickBooksConnected && (
        <QuickBooksProductsDropdownForCatalog control={control as Control<CatalogProductsFormData>} />
      )}

      {isXeroConnected && <XeroProductsDropdownForCatalog control={control as Control<CatalogProductsFormData>} />}

      {isAnrokConnected && <AnrokProductInput control={control as Control<CatalogProductsFormData>} />}
    </Stack>
  );
};
